var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"value",style:({ display: _vm.display, fontSize: _vm.fontSize + 'px', fontWeight: 400 })},[_c('span',[_vm._v(_vm._s(Array.isArray(_vm.amount) ? _vm.amount[0] : _vm.amount))]),(Array.isArray(_vm.amount))?_c('span',{style:({ fontSize: _vm.smallFontSize + 'px' })},[_vm._v("."+_vm._s(_vm.amount[1]))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }